module.exports = __webpack_public_path__ + "static/media/CLP.0347f894.svg";